import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch
} from 'react-router-dom';

import Logged from './flows/logged';

import './App.css';
import SearchReservation from './flows/search-reservation';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasSuggestion: false,
      isLogged: true,
      pnr: '',
      isReady: false
    };
  }

  componentDidMount() {
    this._getPNR();

    this.setState({ isReady: true });
  }

  _getPNR = () => {
    const url = window.location.href.toUpperCase();

    const urlObj = new URL(url);

    const pnrParam = urlObj.searchParams.get('PNR');
    const isEmail = urlObj.searchParams.get('EMAIL') === '';

    if (!pnrParam) {
      this.setState({ isLogged: false });
    } else {
      this.setState({ pnr: pnrParam, email: isEmail });
    }
  };

  _redirectHandler = () => {
    const { isLogged, hasSuggestion, pnr, email } = this.state;
    if (isLogged && email) {
      return {
        pathname: 'u/flight-change',
        state: {
          hasSuggestion,
          pnr,
          email
        }
      };
    } else if (isLogged) {
      return {
        pathname: 'u/flight-introduction',
        state: {
          hasSuggestion,
          pnr
        }
      };
    }
    return 'search-reservation';
  };

  render() {
    const { hasSuggestion, isReady } = this.state;

    if (!isReady) return null;

    return (
      <Router basename={process.env.REACT_APP_NAME}>
        <div>
          <Switch>
            <Route path="/search-reservation" component={SearchReservation} />
            <Route
              path="/u"
              render={routeProps => (
                <Logged hasSuggestion={hasSuggestion} {...routeProps} />
              )}
            />
            <Redirect to={this._redirectHandler()} />
          </Switch>
        </div>
      </Router>
    );
  }
}

export default App;
